<template>
  <li class="accordionItem" ref="acdItem">
    <div class="accordionTrigger" :class="{accordionTriggerActive: visible}" @click="open">
      <slot name="accordion-trigger"></slot>
    </div>
    <transition :css="false" @enter="start" @leave="end">
      <div class="accordionContent" v-if="visible">
        <ul>
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
  import {TweenMax, Power2} from "gsap/all";
  export default {
    name: "AccordionItem",
    props: {},
    inject: ["Accordion"],
    data() {
      return {
        isOpen: false,
        index: null
      };
    },
    computed: {
      visible() {
        if (this.Accordion.multiple) {
          return this.isOpen;
        }
        return this.index === this.Accordion.active;
      }
    },
    methods: {
      open() {
        if (this.Accordion.multiple) {
          this.isOpen = !this.isOpen;
          return;
        }
        if (this.index !== this.Accordion.active) {
          this.Accordion.active = this.index;
        } else {
          this.Accordion.active = null;
        }
      },
      start(el, done) {
        el.style.height = "auto";
        const targetHeight = el.scrollHeight;
        el.style.height = "0px";

        TweenMax.to(el, 0.5, {
          ease: Power2.easeInOut,
          height: targetHeight,
          onComplete: () => {
            el.style.height = "auto";
            done();
          }
        });

        this.bindImageLoadResize(el);
      },
      end(el, done) {
        TweenMax.to(el, 0.5, {
          ease: Power2.easeInOut,
          height: 0,
          onComplete: () => {
            done();
          }
        });
      },
      bindImageLoadResize(el) {
        const resize = () => {
          if (el.offsetHeight > 0) {
            el.style.height = "auto";
          }
        };

        this.$nextTick(() => {
          el.querySelectorAll("img").forEach(img => {
            if (img.complete) {
              resize();
            } else {
              img.addEventListener("load", resize, {once: true});
            }
          });
        });
      }
    },
    created() {
      this.index = this.Accordion.count++;
    }
  };
</script>

<style lang="scss" scoped>
  .accordionContent {
    overflow: hidden;
  }
  .accordionItem {
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    position: relative;
  }

  .accordion-enter-active,
  .accordion-leave-active {
    //will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
  }

  .accordion-enter,
  .accordion-leave-to {
    height: 0 !important;
    opacity: 0;
  }

  .accordionTrigger.accordionTriggerActive {
    .acc-tit {
      color: #ee2c3c;
      &:after {
        background: url(../../assets/images/acc-on.png) no-repeat 0 0/100%;
      }
    }
  }
</style>
